/**
 * Shared chart layout contract for insights/report/widget Recharts hosts.
 * Keeps axis ticks and reference labels inside the drawable area to avoid clipping.
 */

export const INSIGHT_CHART_MARGIN = {
  top: 10,
  right: 12,
  bottom: 0,
  left: 0,
} as const;

export const INSIGHT_CHART_CONTAINER_CLASS = 'w-full min-w-0';

export function insideRightReferenceLabel(value: string) {
  return {
    value,
    position: 'insideRight' as const,
    fontSize: 10,
    fill: 'hsl(var(--muted-foreground))',
    offset: 4,
  };
}
